export enum FinanceTypeEnum {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  DATE = "DATE"
}